import { ServiceCommand } from '../../../../../core/domain/command/service-command';
import { httpClient } from '../../../../../core/infra/http/apolo-http-client-adapter';
import { AUTH_API_ROUTES } from '../../api/routes';
import { ValidateCode } from './validate-code';

export const validateCodeService: ServiceCommand<ValidateCode.Response> =
  new ValidateCode(httpClient, AUTH_API_ROUTES.VALIDATE_EMAIL_CODE);

export type { ValidateCode };
